/** Поле в Parse DB; в админке маппится в `email` */
export const USER_CONTACT_EMAIL_FIELD = 'contactEmail';

export type User = {
    id: string;
    email: string;
    phone: string;
    firstName: string;
    middleName: string;
    lastName: string;
    bonusAmount: number;
    orderNumber: number;
    username: string;
    password: string;
    cityName: string;
    isAllowCashOnDelivery?: boolean;
};